import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { I18nProvider } from './utils/i18n'
import { ThemeProvider } from './utils/theme'
import { ToastProvider } from './components/Toast'
import { ErrorBoundary } from './components/ErrorBoundary'

function maybeRedirectToPublicDev() {
  try {
    const isDev202Ip = window.location.hostname === '192.168.0.202'
    const isHttp = window.location.protocol === 'http:'
    if (!isDev202Ip || !isHttp) return false

    const targetOrigin = 'https://admin-dev.chamii.com'
    const u = new URL(window.location.href)
    window.location.replace(`${targetOrigin}${u.pathname}${u.search}${u.hash}`)
    return true
  } catch {
    return false
  }
}

if (!maybeRedirectToPublicDev()) {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <ErrorBoundary>
        <I18nProvider>
          <ThemeProvider>
            <ToastProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </ToastProvider>
          </ThemeProvider>
        </I18nProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  )
}
